import { useMemo, useState } from 'react';
import type { EditableDealRow } from './editable-deal-row.types';
import {
  appendRow,
  buildBulkPayload,
  hasUnsavedChanges,
  insertRowAt,
  mapDealToRow,
  prependRow,
  removeRowAt,
  validateRows,
} from './row-helpers';

export function useEditableDealsRows(initialDeals: any[]) {
  const original = useMemo(() => initialDeals.map(mapDealToRow), [initialDeals]);
  const [rows, setRows] = useState<EditableDealRow[]>(original);

  const updateRow = (clientId: string, patch: Partial<EditableDealRow>) =>
    setRows((prev) => prev.map((r) => (r.clientId === clientId ? { ...r, ...patch } : r)));

  const insert = (index: number, position: 'above' | 'below') => setRows((prev) => insertRowAt(prev, index, position));
  const remove = (index: number) => setRows((prev) => removeRowAt(prev, index));
  const append = () => setRows((prev) => appendRow(prev));
  const prepend = () => setRows((prev) => prependRow(prev));

  const errors = useMemo(() => validateRows(rows, original), [rows, original]);
  const dirty = useMemo(() => hasUnsavedChanges(rows, original), [rows, original]);

  return {
    rows,
    errors,
    dirty,
    updateRow,
    insert,
    remove,
    append,
    prepend,
    buildPayload: () => buildBulkPayload(rows, original),
  };
}
